/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';

import PropTypes from 'prop-types';
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import MouseSpotlight from "./Animations/MouseSpotlight.jsx";
import InlineInput from "./BasicInputs/InlineInput.jsx";

class CardComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.isDefaultOpen,
            dragHover: false
        };
    }

    render() {
        let {isOpen} = this.state

        let {canBeOpened, isSelected, id, onChangeTitle} = this.props

        let cardStyle
        let textStyle
        switch (this.props.size) {
            case "sm":
                cardStyle = `bg-white px-2 py-1  border-b border-gray-300  rounded  h-9 shadow border flex group ${canBeOpened ? ("cursor-pointer hover:bg-gray-50") : ("")} `
                textStyle = `text-sm leading-6 font-medium text-gray-700 flex items-center justify-between grow`
                break;
            case "base":
            default:
                cardStyle = `bg-white px-4 py-4 border-b border-gray-200 rounded   h-13 shadow border flex group ${canBeOpened ? ("cursor-pointer hover:bg-gray-50") : ("")} `
                textStyle = `text-base leading-6 font-semibold text-gray-900 grow`
                break;


        }


        return (

            <div className="border-gray-300 h-full flex flex-col"
                 onDragEnter={() => {
                     if (!isOpen && !this.props.isEditorMode && canBeOpened) {
                         if (this.props.expandSize !== undefined) {
                             this.props.expandSize(true)
                         }
                         this.setState({isOpen: true})
                     }
                 }}
                 id={id}>
                <MouseSpotlight
                    spotlightSize={150}
                    spotlightColor={"rgba(255,255,255,0.71)"}
                    className={` flex justify-center items-center ${cardStyle}`}
                    onClick={(event) => {
                        // if (!this.state.dragHover) {
                        // Only open this in the editor if the card is selected to prevent it from being closed on selection.
                        if (canBeOpened && (isSelected || !this.props.isEditorMode)) {
                            if (this.props.expandSize !== undefined) {
                                this.props.expandSize(!isOpen)
                            }
                            this.setState({isOpen: !isOpen})
                        }
                        // }
                    }}>
                    {this.props.iconName !== undefined && (<>
                        <DisplayIcon iconName={this.props.iconName} className={"mr-2"}/>
                    </>)}
                    {onChangeTitle !== undefined ? (<>

                        <InlineInput value={this.props.title}
                                     innerRef={this.twinNameRef}
                                     placeholder={`Überschrift`}
                                     className={` h-8 px-2 py-1 w-full hover:bg-stone-50 mr-2 -ml-2 -my-1 rounded !bg-transparent min-w-32 ${textStyle}`}
                                     onChange={(newValue) => {
                                         onChangeTitle(newValue)

                                     }}/>

                    </>) : (<>
                        <h6 className={textStyle}>
                            <>{this.props.title}</>
                        </h6>
                    </>)}

                    {canBeOpened && (
                        <div
                            className={`flex justify-center items-center transition-all duration-300 p-1 text-stone-200 group-hover:text-stone-600 ${isOpen && ("rotate-180 !text-blue-300 group-hover:!text-blue-600")}`}>
                            <DisplayIcon iconName={"PiCaretDown"}/>
                        </div>
                    )}

                </MouseSpotlight>
                <div style={{
                    visibility: (isOpen) ? "visible" : "hidden",
                    opacity: (isOpen) ? "100%" : "0%",
                    maxHeight: (isOpen) ? "100%" : "0px",
                    display: (isOpen) ? "block" : "block",
                    pointerEvents: (isOpen) ? "auto" : "none",
                    padding: (isOpen) ? 12 : 0,
                }}
                     className={`block bg-white flex-grow shadow border border-t-0  overflow-auto transition-max-height transition-opacity customScrollbar duration-150 ease-in-out ${isSelected && (" border-blue-200")}`}>
                    {this.props.children}
                </div>
            </div>

        )
    };
}

CardComponent.propTypes = {
    children: PropTypes.any,
    size: PropTypes.oneOf(["sm", "base"]),
    /**
     * The Titel of the card
     */
    title: PropTypes.string,
    /**
     * Should the card be open on default
     * @default true
     */
    isDefaultOpen: PropTypes.bool,
    isEditorMode: PropTypes.bool,
    canBeOpened: PropTypes.bool
}

CardComponent.defaultProps = {
    isDefaultOpen: false,
    isEditorMode: false,
    title: '',
    size: "base",
    canBeOpened: true
}
export default CardComponent;

